
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Hii imeletwa na mradi wa
                    <a href="${0}">Folksonomy Engine</a>. Usisite
                    kusita kushiriki au kutoa maoni`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Chombo hiki kinakuwezesha kurekebisha orodha ya viungo. Unaweza kuongeza, kuondoa au kuhariri
                orodha ya viungo.
                <br>
                Tabia hii <span class="highlight">␣</span> inawakilisha nafasi.
                <br>
                Herufi hii <span class="highlight">↩︎</span> inawakilisha kukatika kwa mstari. `,
'hb28f1f2ec1744ee9': html`Sifa hizi huundwa na kuwasilishwa na watumiaji kwa aina yoyote ya matumizi. Jisikie
                    huru kuongeza yako mwenyewe. Sifa na thamani unazounda
                    <strong>lazima ziwe za ukweli</strong>. Unaweza kupiga mbizi kwenye
                    <a href="${0}">orodha ya mali ambayo tayari inatumiwa na jumuiya</a>
                    au kuchunguza
                    <a href="${1}">uhifadhi wa mali na injini yake ya utafutaji</a>.`,
's000a5b76bd3a01c2': `Inapakia sifa...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Tusaidie kwa viungo`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Thibitisha mazao`,
's03e9c8114521b998': `Nitahariri viungo`,
's05ec315d9308091a': `Aikoni ya pembe za msimbopau`,
's061eb5af92512c85': `Imehifadhiwa! Unaweza kusaidia na mwingine?`,
's06847c221c4c0bc1': `Ningependa kuunda mali ya [kuelezea kesi yako ya utumiaji] ...`,
's06f6c6f99db6b552': `Asili`,
's081e2ad82db71e1d': `Maadili yaliyowekwa kwenye vikundi`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `nyaraka za kujitolea`,
's0bb2d48532acc455': `Pakua CSV`,
's0d5b7fee0311db68': `Mali`,
's0fb218abc2e157ed': `Batilisha picha`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Ghairi mazao`,
's11a18a69b30b65ed': `Tusaidie kurekebisha makosa katika orodha ya viungo`,
's1205d5f6fccf8e69': `Thamani ya Mali`,
's15d64a0a6715285a': `Ufunguo mpya`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Eneo la uteuzi`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Tusaidie kusahihisha maelezo ya lishe`,
's1e00019dc454872d': `Tafadhali toa jina la mali kwa kutumia sifa ya jina la mali.`,
's1e49126af0935a5b': `Orodha ya bidhaa zinazotumia mali hii`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Ghairi`,
's2db7b654c0a9bde0': `Hati ya mali`,
's300b3a6ee4e1252d': str`Ulinganifu Mbaya ${0}%`,
's33f786bb6b4f0cf4': `Matokeo ya Mazao`,
's33f85f24c0f5f008': `Hifadhi`,
's34be4af4e8fec4ae': `Uliza jamii kwanza`,
's36d86adc823cbfa6': `Kabla ya kuunda mali mpya, ijadili na jumuiya:`,
's3781d25aa51a736c': `Nyaraka za Injini ya Folksonomy`,
's383ae4449428b61e': `Weka upya mazao`,
's39bcf88721a1e8ee': `Weka upya uteuzi`,
's39e14e14300694c7': `Nyaraka na Miongozo`,
's3b430cfa5c1fe7f4': str`Hati za ${0}`,
's3f4e4b52f230a892': `Turubai ya picha`,
's417b90913e05bc17': `Hakiki`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Picha ya katikati`,
's42dd66b2441566fd': `Aikoni ya katikati`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Ongeza virutubisho`,
's453ab0dbb9b5c777': `Badilisha ukubwa wa kulia`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Hesabu ya Bidhaa`,
's4df2f533c0c1e7d0': `Vidhibiti vya picha`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Hamisha uteuzi`,
's4f751fb9b3ed766c': `Kuunda Mali Mpya`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Weka jina la mali...`,
's55d7249883a98ca1': `kuhusu mali hii kwenye wiki ya Open Food Facts`,
's565867d84c04aea2': `Chuja sifa...`,
's5666afe5cd0166de': `Tafadhali rekebisha hitilafu au urekebishe maandishi kabla ya kuthibitisha`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Inapakia bidhaa...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Tusaidie kusahihisha maelezo ya lishe.`,
's5dd6f12783fca34f': `Badilisha orodha ya viungo`,
's5e8250fb85d64c23': `Funga`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Hariri`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Asante kwa mchango wako!`,
's6cee7cad81dfedd1': `Picha Iliyopunguzwa`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Mechi Nzuri ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Nyaraka`,
's787dd11bed0dc88a': `Badilisha ukubwa wa kushoto`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Pata maelezo zaidi kuhusu uundaji wa mali na miongozo:`,
's8038273de2cf8b73': `Tafadhali chagua eneo la kupunguza.`,
's839cc2908a5387f2': `Chuja misimbo pau...`,
's86197dcf3e96af64': `Vinjari na utafute mali zilizopo`,
's8a63be30a129a59c': `Badilisha ukubwa chini`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Badilisha ukubwa wa juu kulia`,
's8db84aa4bc949af2': `Hati ya Mali Mpya`,
's8f839a03997a16d7': `Tazama Bidhaa`,
's901ae1e236ac45d3': `Ghairi kufuta`,
's907f7a97c6b29425': `Fahamu kwamba muundo wa data unaweza kubadilishwa. Tumia kwa hatari yako mwenyewe.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Viungo:`,
's9a7f60fce090ecaf': `Imeshindwa kupakia sifa. Tafadhali jaribu tena baadaye.`,
's9b87abd68fb9df45': `Haijapatikana? Unda ufunguo mpya {value}`,
's9c0f52425fd2f07e': `Huenda Isifanane`,
's9fc41f789c63b40d': `Bidhaa`,
'sa1fa766e0d5634d7': `Hakuna Alama Inayopatikana`,
'sa548778b24054030': `Chunguza mali zote zilizochangiwa kutoka kwa mradi wa Injini ya Folksonomy. Sifa hizi hutoa metadata ya ziada na maarifa kuhusu bidhaa katika hifadhidata ya Ukweli wa Chakula Huria.`,
'sa63907958bd0ec4b': `Badilisha ukubwa wa juu kushoto`,
'sa95b4224f685a36a': `Funga modali`,
'sab56a1d439576fd6': `Aikoni ya pendekezo`,
'sac47ea2901d04c15': `Badilisha ukubwa chini kushoto`,
'sb125227d436c2925': `Tafuta dhana ya mali yako katika hifadhidata ya mali iliyopo:`,
'sb125568d43642e6f': `Jibu maswali kuhusu bidhaa.`,
'sb1c538e038f9b214': str`Mechi Nzuri Sana ${0}%`,
'sb28639570ff3b852': `orodha ya mali zote`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Mara tu unapothibitisha kuwa mali yako haipo na jumuiya inakubali kuwa ni muhimu, unahitaji kwanza kuihifadhi kwenye wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Hakuna bidhaa zilizopatikana za mali hii.`,
'sb7f72e4c8a2d3357': `Chuja thamani...`,
'sb8178320160f84ea': `Onyesha mazao`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Maarifa yote yamejibiwa! Asante kwa msaada wako!`,
'sbd9a0b2293b3cd3c': `Saizi ya kutumikia`,
'sbe472dc3c2685985': `Thamani Sambamba`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Badilisha ukubwa wa juu`,
'sc1c08d0cbcc3bd24': `Hailingani`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Marekebisho yaliyopendekezwa`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Sogeza picha`,
'sc895972c88d38ca5': `Mali ya Folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Safu`,
'scb3b0671d7b7f640': `Thamani mpya`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Jiunge na Majadiliano ya Slack`,
'scdb6cad0b92721bf': `Hakuna sifa zilizopatikana.`,
'scf23a05631f93732': `Thibitisha Futa`,
'scfed2f270ef6a3aa': `Chagua eneo`,
'sd1022bc1ef9204f7': `Picha inayoweza kukuza`,
'sd1077c055cf9ba6b': `Tusaidie kuthibitisha orodha ya viambato vya bidhaa.`,
'sd698d21ddecba56b': `Habari! Unaweza kutusaidia kuboresha maelezo ya bidhaa kwa kujibu sehemu zifuatazo:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Angalia ikiwa mali tayari iko`,
'sdbf806fefc584115': `Unapaswa kupata a`,
'sdc673e73b5c13aea': `Futa`,
'sdc792b75f1edcaba': `Tusaidie kusahihisha tahajia ya viungo.`,
'sdca5deead576ceee': `Badilisha ukubwa chini kulia`,
'sdcc2555c5dde524f': `Je, una uhakika unataka kufuta kipengee hiki? Kitendo hiki hakiwezi kutenduliwa.`,
'se206feec7ec57b28': `kwa 100g`,
'se419a9ab36987490': `Batilisha`,
'se5127cf0f92e7e48': `Kidokezo: unaweza pia kupata`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Nitapendekeza mazao bora`,
'seea3800e27baa686': `Bidhaa za Mtu Binafsi`,
'sefaba4adc4ec9219': `Sifa za Folksonomy`,
'seffa8ca49175b5f0': `Sifa zilizobinafsishwa`,
'sf44a6b3b232c28ea': str`Badilisha thamani ya sasa kwa ${0}`,
'sf4cd86a2f5ef2588': `Msimbo wa bidhaa`,
'sf57a61152168cc81': `Tusaidie kusahihisha utambuzi wa kiungo`,
'sf88b90b8ba23871c': `Mechi Isiyojulikana`,
'sf9aee319a006c9b4': `Ongeza`,
'sfacbbe968fa7d773': `Jina la mali:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Thamani inayolingana`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  